import { AutomatedAuditLoader, Button, Modal, Popover } from "@common/components";
import { Edit, MoreVertical, QuestionCircle, Trash2 } from "@geist-ui/icons";
import { ActionIcon, Divider, Flex, Space, Title, Tooltip, UnstyledButton } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import CardComponent from "src/components/CardComponent";
import { ComplianceScoreCard } from "src/components/dashboardGraphs/ScoreProgress/components";
import LineChart from "src/components/LineChart";
import { CHART_OPTIONS } from "src/components/LineChart/constants";
import { setSelectedDashboard, useAppDispatch, useAppSelector } from "src/store";
import { BarChartOptionComponent, DashboardTableRanking, DashboardTableRankingRisk, GaugeChartOptionComponent, LineChartOptionComponent, MultipleBarHorizantalOption, PieChart, PieChartOptionComponent, PieChartOptionComponentPriority, ScanProgressChart, ScanProgressChartOptions, SemicircleOption, WebsiteScoreChartOptionComponent, } from "./ChartOptionsPerType";
import { SemiCircleProgress } from "src/components/progressBars";
import { UsageChart } from "src/components/UsageCharts";
import { Bar } from "react-chartjs-2";
import GaugeChart from "react-gauge-chart";
import styles from "../styles.module.scss"
import classNames from "classnames";
import { apiInstance } from "src/services";
import { useDisclosure } from "@mantine/hooks";
import { ReactComponent as EmptyTable } from 'src/assets/svg/empty-table.svg';
import { Link } from "react-router-dom";
import { LineProgressProps } from "@common/types/types";
import { wcag_guidelines } from "src/constants/wcag_guidelines";

type SiteListType = {
    siteUUID: string, score: number, name: string
}
interface Props {
    contentData: {


        accessibilityScoreProgress: {
            target: number;
            critical: number;
            actual:
            | {
                date: string;
                value: number;
            }[]
            | undefined;
        } | null;
        complianceScore: number;
        complianceLevel: string;
        description: string;
        criteriaPassed: number;
        criteriaNotTested: number;
        criteriaFailed: number;
        issuesCountByPriority: {
            warning: number,
            medium: number,
            low: number,
            high: number,
            critical: number,
        };
        numberOfIssues: number;
        closedIssues: number;
        newsIssues: number;
        openIssues: number;
        commonIssues: {
            [key: string]: {
                [key: string]: number
            };
        };
        commonSeccess: {
            [key: string]: {
                [key: string]: number
            };
        };
        webSitesData: Array<SiteListType>;
        issuesCountOverTime: {
            actual: Array<{
                date: string,
                totalIssues: number,
                closedIssues: number,
                openIssues: number
            }>
        },
        ialabsScore: number
    }
}
function DisplayChartsByDashboard({ contentData }: Props) {
    const { dashboard, charts, loading } = useAppSelector((state) => state.dashboardCharts, shallowEqual);
    const dispatch = useAppDispatch();
    const [openedEdit, { open: openEdit, close: closeEdit }] = useDisclosure(false);
    const [selectedChart, setSelectedChart] = useState<any>(null)

    const [t] = useTranslation('siteList');
    const [c] = useTranslation('common');
    const groupedData =
        contentData?.accessibilityScoreProgress?.actual?.length && contentData?.accessibilityScoreProgress?.actual?.length > 20
            ? contentData?.accessibilityScoreProgress.actual.slice(
                contentData?.accessibilityScoreProgress.actual.length - 20,
                contentData?.accessibilityScoreProgress.actual.length,
            )
            : contentData?.accessibilityScoreProgress?.actual;
    const labels = groupedData?.map((item) => item.date);
    const values = groupedData?.map((item) => item.value);

    let ChartObjectCommonSeccess: { labels: Array<string>, datasets: Array<number> } = {
        labels: [],
        datasets: [],
    }
    const commonAccessibilityIssuesData_options = {
        responsive: true,
        plugins: {
            datalabels: { display: false },
            tooltip: {
                callbacks: {
                    label: (context: any) => {
                        let label = "";
                        if (context.parsed.y) {
                            label = parseInt(context.parsed.y) + "%";
                        }
                        return label;
                    }
                }
            }
        },
        onClick: (event: any, elements: any, chart: any) => {
            // Check if a bar element was clicked
            // if (elements.length > 0) {
            //     const elementIndex = elements[0].index; // Index of the clicked bar
            //     const label = chart.data.labels[elementIndex]; // Label of the clicked bar
            //     // Redirect based on the label
            //     const url = `/insight/dashboard/test.vially.ie/automated-audit?Criteria=${label}`;
            //     window.open(url, '_blank');
            // }
        }
    };


    let ChartObjectCommonIssues: { labels: Array<string>, datasets: Array<number> } = {
        labels: [],
        datasets: [],
    }

    contentData?.commonIssues && Object.entries(contentData?.commonIssues).map((elm, index) => {
        if (elm) {
            const label = `${elm[0]}-${wcag_guidelines[elm[0]]}` 
            
            elm[0] && ChartObjectCommonIssues.labels.push(label)
            elm[1] && ChartObjectCommonIssues.datasets.push( Math.trunc(elm[1]?.nbrOfIssues))
        }

        return elm
    })
    // const commonAccessibilityWCAGData = {
    //     labels: ChartObjectCommonIssues?.labels, // Success criteria codes and descriptions
    //     datasets: [
    //         {
    //             label: 'Number of Issues',
    //             data: ChartObjectCommonIssues.datasets, // Example values representing the number of occurrences
    //             backgroundColor: ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF', '#ffd700a6'],
    //             borderWidth: 1,
    //         },
    //     ],
    // };



    const getSCoreColor = (score: number) => {

        if (score > 50) {
            return "#da604e";
        } else if (score >= 30) {
            return "#035e11b0";
        } else {
            return "#a3e6e1"
        }
    }
    return (
        <div className={!loading && charts?.length > 0 ? styles.gridColums : ''} >
            {
                loading ?
                    <Flex h={"40vh"} justify={"center"} align={"center"} w={"100%"} style={{ margin: '0 auto' }} direction={"column"} >
                        <AutomatedAuditLoader />
                        <p>loading ..</p>
                    </Flex> :
                    charts && charts?.length > 0 ? charts.map((chart: any) => {
                        // const dataSetConfig = chart?.dataset?.datasets?.map((ds: any) => ds);
                        const dataChart1 = [
                            {
                                data: values,
                                label: chart?.dataset?.CompliantScore?.name ?? 'Compliant Score',
                                borderColor: chart?.dataset?.CompliantScore?.borderColor ?? "#035e11b0",
                                backgroundColor: chart?.dataset?.CompliantScore?.backgroundColor ?? "#035e11b0",
                                pointBackgroundColor: chart?.dataset?.CompliantScore?.pointBackgroundColor ?? "#035e11b0",
                                borderWidth: chart?.dataset?.CompliantScore?.borderWidth,
                                pointBorderWidth: chart?.dataset?.CompliantScore?.pointBorderWidth,
                                labelBorderWidth: chart?.dataset?.CompliantScore?.labelBorderWidth,
                                fill: chart?.dataset?.CompliantScore?.fill,
                                lineTension: chart?.dataset?.CompliantScore?.lineTension,
                                pointHoverRadius: chart?.dataset?.CompliantScore?.pointHoverRadius,
                                pointRadius: chart?.dataset?.CompliantScore?.pointRadius,
                                pointHitRadius: chart?.dataset?.CompliantScore?.pointHitRadius
                            },
                            {
                                data: Array.from({ length: labels?.length as number }).fill(contentData?.accessibilityScoreProgress?.target),
                                label: chart?.dataset?.Target?.name ?? 'Target',
                                borderColor: chart?.dataset?.Target?.borderColor ?? "#da604e",
                                backgroundColor: chart?.dataset?.Target?.backgroundColor ?? "#da604e",
                                pointBackgroundColor: chart?.dataset?.Target?.pointBackgroundColor ?? "#da604e",
                                borderWidth: chart?.dataset?.Target?.borderWidth,
                                pointBorderWidth: chart?.dataset?.Target?.pointBorderWidth,
                                labelBorderWidth: chart?.dataset?.Target?.labelBorderWidth,
                                fill: chart?.dataset?.Target?.fill,
                                lineTension: chart?.dataset?.Target?.lineTension,
                                pointHoverRadius: chart?.dataset?.Target?.pointHoverRadius,
                                pointRadius: chart?.dataset?.Target?.pointRadius,
                                pointHitRadius: chart?.dataset?.Target?.pointHitRadius
                            },
                            {
                                label: chart?.dataset?.Critical?.name ?? 'Critical',
                                data: Array.from({ length: labels?.length as number }).fill(contentData?.accessibilityScoreProgress?.critical),
                                borderColor: chart?.dataset?.Critical?.borderColor ?? "#2A2B4B",
                                backgroundColor: chart?.dataset?.Critical?.backgroundColor ?? "#2A2B4B",
                                pointBackgroundColor: chart?.dataset?.Critical?.pointBackgroundColor ?? "#2A2B4B",
                                borderWidth: chart?.dataset?.Critical?.borderWidth,
                                pointBorderWidth: chart?.dataset?.Critical?.pointBorderWidth,
                                labelBorderWidth: chart?.dataset?.Critical?.labelBorderWidth,
                                fill: chart?.dataset?.Critical?.fill,
                                lineTension: chart?.dataset?.Critical?.lineTension,
                                pointHoverRadius: chart?.dataset?.Critical?.pointHoverRadius,
                                pointRadius: chart?.dataset?.Critical?.pointRadius,
                                pointHitRadius: chart?.dataset?.Critical?.pointHitRadius
                            },
                        ];


                        let multipleBarData: LineProgressProps[] | { label: string; value: number; color: any; }[] = [];
                        let total;
                        let closed;
                        let newIssue;
                        let open;
                        if (chart?.dataSource == 'issues_count') {
                            total = chart?.dataset?.data?.find((d: any) => d.label === 'Total Issues');
                            closed = chart?.dataset?.data?.find((d: any) => d.label === 'Closed Issues');
                            newIssue = chart?.dataset?.data?.find((d: any) => d.label === 'New Issues');
                            open = chart?.dataset?.data?.find((d: any) => d.label === 'Open Issues');
                            multipleBarData = [
                                { label: 'Total Issues', value: parseInt(String(contentData?.numberOfIssues)), color: total?.color },
                                { label: 'Closed Issues', value: parseInt(String(contentData?.closedIssues)), color: closed?.color },
                                { label: 'New Issuels', value: parseInt(String(contentData?.newsIssues)), color: newIssue?.color },
                                { label: 'Open Issues', value: parseInt(String(contentData?.openIssues)), color: open?.color },
                            ]

                        }
                        return (chart?.dataSource && !['accessibility_score_progress', 'accessibility_impact', 'most_common_accessibility_issues', "compliance_score",
                            "accessibility_score", 'total_issues_over_time'].includes(chart.dataSource)) && <div key={chart.id} className={styles.child} >
                                {

                                    <CardComponent

                                        title={chart.chartName}
                                        popover={chart?.popover}
                                        icon={
                                            <Flex gap={"sm"} align={"center"}>
                                                {/* <Tooltip label="Learn More">
                                                    <Link to={'/faq'} target='_blank' aria-label='navigate to frequently asked question to learn more about this chart'> <QuestionCircle aria-hidden='true' /> </Link>
                                                </Tooltip> */}


                                                <Popover
                                                    trapFocus={true}
                                                    target={
                                                        <Tooltip label="More Options">
                                                            <ActionIcon title='More Options'>
                                                                <MoreVertical color="#000000" />
                                                            </ActionIcon>
                                                        </Tooltip>
                                                    }
                                                    dropdownTarget={
                                                        <Flex justify={"start"} align={"start"} gap={"sm"} direction={"column"} className={classNames(styles['popover-container'])}>
                                                            <UnstyledButton
                                                                onClick={async () => {
                                                                    const response = await apiInstance.delete(`reporttool/dashboard/charts/${chart.id}`);

                                                                    if (response?.data?.message) {
                                                                        dispatch(setSelectedDashboard({ dashboard_id: chart?.dashboard_id }))
                                                                    }
                                                                }}
                                                                className={styles['delete-btn']}>
                                                                Delete Chart
                                                                <Trash2 color="#da604e" />
                                                            </UnstyledButton>
                                                            <UnstyledButton onClick={() => {
                                                                setSelectedChart(chart)
                                                                openEdit()
                                                            }} className={styles['delete-btn']}>
                                                                Edit Chart
                                                                <Edit />
                                                            </UnstyledButton>

                                                            {/* 
                            <UnstyledButton onClick={() => moveItem(index, 'left')}
                                disabled={index % 2 === 0} className={styles['delete-btn']}>
                                Left
                                <ArrowLeft />
                            </UnstyledButton>
                            <UnstyledButton onClick={() => moveItem(index, 'up')}
                                disabled={index < 2} className={styles['delete-btn']}>
                                Up
                                <ArrowUp />
                            </UnstyledButton>
                            <UnstyledButton onClick={() => moveItem(index, 'right')}
                                disabled={index % 2 !== 0 || index === items.length - 1} className={styles['delete-btn']}>
                                Right
                                <ArrowRight />
                            </UnstyledButton>
                            <UnstyledButton onClick={() => moveItem(index, 'down')}
                                disabled={index >= items.length - 2} className={styles['delete-btn']}>
                                Down
                                <ArrowDown />
                            </UnstyledButton> */}

                                                        </Flex>
                                                    }></Popover>


                                            </Flex>
                                        }
                                    >


                                        {/* {
                                        chart?.dataSource == 'accessibility_score_progress' &&
                                        <>
                                            <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>
                                                <Flex direction={"column"} justify={"space-between"} style={{ flexGrow: 1, width: '100%', height: '100%' }}>
                                                    <LineChart w={true} options={CHART_OPTIONS()} data={{
                                                        labels,
                                                        datasets: dataChart1,

                                                    }} />
                                                </Flex>
                                            </div>
                                            <table style={{
                                                border: "1px solid #ddd",
                                                borderCollapse: "collapse",
                                                width: '100%',
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                backgroundColor: "#f9f9f9"
                                            }}>
                                                <thead>
                                                    <tr style={{
                                                        backgroundColor: "#f2f2f2",
                                                        borderBottom: "2px solid #ccc"
                                                    }}>
                                                        <th style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px",
                                                            textAlign: "left",
                                                            fontWeight: "bold"
                                                        }}>Label</th>
                                                        <th style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px",
                                                            textAlign: "left"
                                                        }}>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        dataChart1.map((dataset, index) => (
                                                            <tr style={{
                                                                borderBottom: "1px solid #ddd"
                                                            }} key={index} className={dataset.label.replace(/\s+/g, "-")}>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px"
                                                                }}>
                                                                    <Flex align={"center"} gap={"sm"} >
                                                                        <span style={{ width: '20px', height: '20px', background: dataset?.backgroundColor, borderRadius: '1rem' }}></span>
                                                                        {dataset.label}
                                                                    </Flex>
                                                                </td>
                                                                <td style={{
                                                                    padding: "10px",
                                                                    border: "1px solid #ddd"
                                                                }}>
                                                                    {labels && labels[index] ? labels[index] : 'N/A'}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </>
                                    } */}
                                        {

                                            chart?.dataSource == 'vially_accessibility_overview' &&
                                            <>
                                                <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>

                                                    <ComplianceScoreCard
                                                        complianceScore={ Math.trunc(contentData?.complianceScore) ?? 0 }
                                                        complianceLevel={contentData?.complianceLevel}
                                                        description={contentData?.description}
                                                        number_passed={ Math.trunc(contentData?.criteriaPassed) ?? 0}
                                                        cant_tested={ Math.trunc(contentData?.criteriaNotTested) ?? 0 }
                                                        number_that_fails={ Math.trunc(contentData?.criteriaFailed) ?? 0 }
                                                        colors={[chart?.dataset?.Passed?.backgroundColor ?? "#035e11b0", chart?.dataset?.Failed?.backgroundColor ?? "#da604e", chart?.dataset?.Tested?.backgroundColor ?? "#2A2B4B"]}
                                                    />

                                                </div>
                                                <table style={{
                                                    border: "1px solid #ddd",
                                                    borderCollapse: "collapse",
                                                    width: '100%',
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    backgroundColor: "#f9f9f9"
                                                }}>
                                                    <thead>
                                                        <tr style={{
                                                            backgroundColor: "#f2f2f2",
                                                            borderBottom: "2px solid #ccc"
                                                        }}>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left",
                                                                fontWeight: "bold"
                                                            }}>Label</th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left"
                                                            }}>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px" // Consistent padding
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Passed?.backgroundColor ?? "#035e11b0", borderRadius: '1rem' }}></span>
                                                                    Criteria Passed
                                                                </Flex>
                                                            </td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.criteriaPassed)}</td>
                                                        </tr>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px" // Consistent padding
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Failed?.backgroundColor ?? "#da604e", borderRadius: '1rem' }}></span>
                                                                    Criteria Not Tested
                                                                </Flex>
                                                            </td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.criteriaNotTested)}</td>
                                                        </tr>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd" // Consistent border styling
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px" // Consistent padding
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Tested?.backgroundColor ?? "#2A2B4B", borderRadius: '1rem' }}></span>
                                                                    Criteria Failed
                                                                </Flex></td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.criteriaFailed)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </>
                                        }

                                        {

                                            chart?.dataSource == 'issues_by_priority' &&
                                            <>

                                                <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>
                                                    <PieChart
                                                        labels={[
                                                            chart?.dataset?.Warning?.label,
                                                            chart?.dataset?.Low?.label,
                                                            chart?.dataset?.Medium?.label,
                                                            chart?.dataset?.High?.label,
                                                            chart?.dataset?.Critical?.label
                                                        ]}
                                                        warning={ Math.trunc(contentData?.issuesCountByPriority?.warning) ?? 0}
                                                        medium={ Math.trunc(contentData?.issuesCountByPriority?.medium) ?? 0}
                                                        low={ Math.trunc(contentData?.issuesCountByPriority?.low) ?? 0}
                                                        high={ Math.trunc(contentData?.issuesCountByPriority?.high) ?? 0}
                                                        critical={ Math.trunc(contentData?.issuesCountByPriority?.critical) ?? 0}
                                                        colors={[
                                                            chart?.dataset?.Warning?.backgroundColor ?? "#035e11b0",
                                                            chart?.dataset?.Low?.backgroundColor ?? "#2A2B4B",
                                                            chart?.dataset?.Medium?.backgroundColor ?? "#da604e",
                                                            chart?.dataset?.High?.backgroundColor ?? "#FF8C00",
                                                            chart?.dataset?.Critical?.backgroundColor ?? "#B22222"]}
                                                    />

                                                </div>
                                                <table style={{
                                                    border: "1px solid #ddd",
                                                    borderCollapse: "collapse",
                                                    width: '100%',
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    backgroundColor: "#f9f9f9"
                                                }}>
                                                    <thead>
                                                        <tr style={{
                                                            backgroundColor: "#f2f2f2",
                                                            borderBottom: "2px solid #ccc"
                                                        }}>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left",
                                                                fontWeight: "bold"
                                                            }}>Label</th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left"
                                                            }}>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Warning?.backgroundColor ?? "#035e11b0", borderRadius: '1rem' }}></span>
                                                                    {chart?.dataset?.Warning?.label ?? 'Warning'}
                                                                </Flex>
                                                            </td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.issuesCountByPriority?.warning) ?? 0}</td>
                                                        </tr>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Low?.backgroundColor ?? "#2A2B4B", borderRadius: '1rem' }}></span>
                                                                    {chart?.dataset?.Low?.label ?? 'Low'}
                                                                </Flex></td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.issuesCountByPriority?.low) ?? 0}</td>
                                                        </tr>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Medium?.backgroundColor ?? "#da604e", borderRadius: '1rem' }}></span>
                                                                    {chart?.dataset?.Medium?.label ?? 'Medium'}
                                                                </Flex>
                                                            </td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.issuesCountByPriority?.medium) ?? 0}</td>
                                                        </tr>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.High?.backgroundColor ?? "#FF8C00", borderRadius: '1rem' }}></span>
                                                                    {chart?.dataset?.High?.label ?? 'High'}
                                                                </Flex></td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.issuesCountByPriority?.high) ?? 0}</td>
                                                        </tr>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.Critical?.backgroundColor ?? "#B22222", borderRadius: '1rem' }}></span>
                                                                    {chart?.dataset?.Critical?.label ?? 'Critical'}
                                                                </Flex></td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{ Math.trunc(contentData?.issuesCountByPriority?.critical) ?? 0}</td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </>

                                        }




                                        {

                                            chart?.dataSource == 'vially_score' &&

                                            <>

                                                <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>
                                                    <div style={{ width: '100%' }}>
                                                        <SemiCircleProgress
                                                            stroke={chart?.dataset?.color}
                                                            percentage={contentData?.complianceScore ? parseInt(String(contentData?.complianceScore)) : 0}
                                                            showPercentValue={true}
                                                            diameter={300}
                                                            strokeWidth={20}
                                                        />
                                                        <p style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700' }}>Vially Score : {contentData?.complianceScore ? parseInt(String(contentData?.complianceScore)) : 0}%</p>
                                                        <p style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700' }} >
                                                            <Link target='_blank' to="/faq?tab=vially-score" >What Is Vially Score</Link>
                                                        </p>
                                                    </div>
                                                    <Space h={"sm"} />
                                                </div>
                                                <table style={{
                                                    border: "1px solid #ddd",
                                                    borderCollapse: "collapse",
                                                    width: '100%',
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    backgroundColor: "#f9f9f9"
                                                }}>
                                                    <thead>
                                                        <tr style={{
                                                            backgroundColor: "#f2f2f2",
                                                            borderBottom: "2px solid #ccc"
                                                        }}>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left",
                                                                fontWeight: "bold"
                                                            }}>Label</th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left"
                                                            }}>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{
                                                            borderBottom: "1px solid #ddd"
                                                        }}>
                                                            <td style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px"
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"} >
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.color, borderRadius: '1rem' }}></span>
                                                                    Vially Score
                                                                </Flex>
                                                            </td>
                                                            <td style={{
                                                                padding: "10px",
                                                                border: "1px solid #ddd"
                                                            }}>{contentData?.complianceScore ? parseInt(String((contentData?.complianceScore))) : 0}%</td>
                                                        </tr>
                                                    </tbody>
                                                </table>


                                            </>
                                        }

                                        {
                                            chart?.dataSource == 'issues_count' &&
                                            <div style={{ width: '100%', height: '300px', justifyContent: 'center' }}>
                                                <UsageChart isPercent={false}
                                                    data={multipleBarData} noShadow />
                                                <Space h={"sm"} />


                                                <div>
                                                    <table style={{
                                                        border: "1px solid #ddd", // Lighter border color for a softer look
                                                        borderCollapse: "collapse",
                                                        width: '100%',
                                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
                                                        backgroundColor: "#f9f9f9" // Light background for better readability
                                                    }}>
                                                        <thead>
                                                            <tr style={{
                                                                backgroundColor: "#f2f2f2", // Slightly darker background for header
                                                                borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
                                                            }}>
                                                                <th style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px", // More padding for a spacious look
                                                                    textAlign: "left", // Align text to the left for default
                                                                    fontWeight: "bold" // Bold text for headers
                                                                }}>Label</th>
                                                                <th style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px",
                                                                    textAlign: "left"
                                                                }}>Value</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style={{
                                                                borderBottom: "1px solid #ddd" // Consistent border styling
                                                            }}>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>
                                                                    <Flex align={"center"} gap={"sm"} >
                                                                        <span style={{ width: '20px', height: '20px', background: total?.color ?? '#2A2B4B', borderRadius: '1rem' }}></span>
                                                                        Total Issues
                                                                    </Flex>
                                                                </td>

                                                                <td style={{
                                                                    padding: "10px",
                                                                    border: "1px solid #ddd"
                                                                }}>{parseInt(String(contentData?.numberOfIssues))}</td>
                                                            </tr>
                                                            <tr style={{
                                                                borderBottom: "1px solid #ddd" // Consistent border styling
                                                            }}>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>
                                                                    <Flex align={"center"} gap={"sm"} >
                                                                        <span style={{ width: '20px', height: '20px', background: newIssue?.color ?? '#2A2B4B', borderRadius: '1rem' }}></span>
                                                                        New Issues
                                                                    </Flex></td>
                                                                <td style={{
                                                                    padding: "10px",
                                                                    border: "1px solid #ddd"
                                                                }}>{parseInt(String(contentData?.newsIssues))}</td>
                                                            </tr>

                                                            <tr style={{
                                                                borderBottom: "1px solid #ddd" // Consistent border styling
                                                            }}>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>
                                                                    <Flex align={"center"} gap={"sm"} >
                                                                        <span style={{ width: '20px', height: '20px', background: open?.color ?? '#2A2B4B', borderRadius: '1rem' }}></span>
                                                                        Open Issues
                                                                    </Flex>
                                                                </td>

                                                                <td style={{
                                                                    padding: "10px",
                                                                    border: "1px solid #ddd"
                                                                }}>{parseInt(String(contentData?.openIssues))}</td>
                                                            </tr>
                                                            <tr style={{
                                                                borderBottom: "1px solid #ddd" // Consistent border styling
                                                            }}>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>
                                                                    <Flex align={"center"} gap={"sm"} >
                                                                        <span style={{ width: '20px', height: '20px', background: closed?.color ?? '#2A2B4B', borderRadius: '1rem' }}></span>
                                                                        Closed Issues
                                                                    </Flex>
                                                                </td>
                                                                <td style={{
                                                                    padding: "10px",
                                                                    border: "1px solid #ddd"
                                                                }}>{parseInt(String(contentData?.closedIssues))}</td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }

                                        {
                                            chart?.dataSource == 'most_common_accessibility_issues' &&
                                            <>

                                                <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>
                                                    <div style={{ width: '100%' }}>
                                                        <Bar data={{
                                                            labels: ChartObjectCommonSeccess?.labels,
                                                            datasets: [
                                                                {
                                                                    label: chart?.dataset?.chartLabel ?? 'Number of Issues',
                                                                    data: ChartObjectCommonSeccess?.datasets,
                                                                    backgroundColor: chart?.dataset?.colors ?? ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF'],
                                                                    borderWidth: 1,

                                                                },
                                                            ],
                                                        }} options={commonAccessibilityIssuesData_options} />

                                                    </div>
                                                    <Space h={"sm"} />

                                                </div>
                                                <table style={{
                                                    border: "1px solid #ddd",
                                                    borderCollapse: "collapse",
                                                    width: '100%',
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    backgroundColor: "#f9f9f9"
                                                }}>
                                                    <thead>
                                                        <tr style={{
                                                            backgroundColor: "#f2f2f2",
                                                            borderBottom: "2px solid #ccc"
                                                        }}>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left",
                                                                fontWeight: "bold"
                                                            }}>Label</th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left"
                                                            }}>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            ChartObjectCommonSeccess?.labels?.map((label, index) => {
                                                                const c = ["#a3e6e1", "#da604e", "#2a2b4b", "#5b5eff", "#ffe559"];
                                                                const color = c[index % c.length]; // wrap color index if index is too large

                                                                return (
                                                                    <tr
                                                                        key={label}
                                                                        style={{
                                                                            borderBottom: "1px solid #ddd"
                                                                        }}>
                                                                        <td style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "10px"
                                                                        }}>
                                                                            <Flex align={"center"} gap={"sm"}>
                                                                                <span style={{ width: '20px', height: '20px', background: color, borderRadius: '1rem' }}></span>
                                                                                <Link className={styles.link} to={`https://vially.io/${label}#main-content`}>{label}</Link>
                                                                            </Flex>
                                                                        </td>
                                                                        <td style={{
                                                                            padding: "10px",
                                                                            border: "1px solid #ddd"
                                                                        }}>{parseInt(String(ChartObjectCommonSeccess?.datasets[index]))}%</td>
                                                                    </tr>
                                                                )
                                                            })

                                                        }
                                                    </tbody>
                                                </table>

                                            </>

                                        }


                                        {
                                            chart?.dataSource == 'most_common_success_criteria' &&

                                            <>
                                                <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>

                                                    <div style={{ width: '100%' }}>
                                                        <Bar data={{
                                                            labels: ChartObjectCommonIssues?.labels,
                                                            datasets: [
                                                                {
                                                                    label: chart?.dataset?.chartLabel ?? 'Number of Issues',
                                                                    data: ChartObjectCommonIssues.datasets,
                                                                    backgroundColor: chart?.dataset?.colors ?? ['#A3E6E1', '#DA604E', '#2A2B4B', '#5B5EFF', '#ffd700a6'],
                                                                    borderWidth: 1,
                                                                },
                                                            ],
                                                        }} options={commonAccessibilityIssuesData_options} />

                                                    </div>
                                                    <Space h={"sm"} />
                                                </div>
                                                <table style={{
                                                    border: "1px solid #ddd",
                                                    borderCollapse: "collapse",
                                                    width: '100%',
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    backgroundColor: "#f9f9f9"
                                                }}>
                                                    <thead>
                                                        <tr style={{
                                                            backgroundColor: "#f2f2f2",
                                                            borderBottom: "2px solid #ccc"
                                                        }}>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left",
                                                                fontWeight: "bold"
                                                            }}>Label</th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px",
                                                                textAlign: "left"
                                                            }}>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            ChartObjectCommonIssues?.labels?.map((label, index) => {
                                                                return (
                                                                    <tr
                                                                        key={label}
                                                                        style={{
                                                                            borderBottom: "1px solid #ddd"
                                                                        }}>
                                                                        <td style={{
                                                                            border: "1px solid #ddd",
                                                                            padding: "10px"
                                                                        }}>
                                                                            <Flex align={"center"} gap={"sm"}>
                                                                                <span style={{ width: '20px', height: '20px', background: '#A3E6E1', borderRadius: '1rem' }}></span>
                                                                                <Link className={styles.link} to={`https://vially.io/${label}#main-content`}>{label}</Link>
                                                                            </Flex>
                                                                        </td>
                                                                        <td style={{
                                                                            padding: "10px",
                                                                            border: "1px solid #ddd"
                                                                        }}>{ Math.trunc(ChartObjectCommonIssues?.datasets[index])}</td>
                                                                    </tr>
                                                                )
                                                            })

                                                        }
                                                    </tbody>
                                                </table>
                                            </>
                                        }


                                        {/* {
                                        chart?.dataSource == 'compliance_score' &&

                                        <>
                                            <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>


                                                <div style={{ width: '90%', margin: '0 auto' }}>
                                                    <GaugeChart
                                                        style={{ width: '100%' }}
                                                        id="gauge-chart2"
                                                        percent={contentData?.complianceScore / 100}
                                                        textColor={chart?.dataset?.textColor}
                                                        needleColor={chart?.dataset?.needleColor ?? "#035e11b0"}
                                                        colors={chart?.dataset?.colors ?? ["#035e11b0"]}
                                                    />
                                                </div>
                                                <div style={{ width: '100%', textAlign: 'center' }}>
                                                    <Link style={{ textAlign: "center" }} to="/faq" >What is Compliance Score Overview</Link>
                                                </div>
                                            </div>
                                            <table style={{
                                                border: "1px solid #ddd", // Lighter border color for a softer look
                                                borderCollapse: "collapse",
                                                width: '100%',
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
                                                backgroundColor: "#f9f9f9" // Light background for better readability
                                            }}>
                                                <thead>
                                                    <tr style={{
                                                        backgroundColor: "#f2f2f2", // Slightly darker background for header
                                                        borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
                                                    }}>
                                                        <th style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px", // More padding for a spacious look
                                                            textAlign: "left", // Align text to the left for default
                                                            fontWeight: "bold" // Bold text for headers
                                                        }}>Label</th>
                                                        <th style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px",
                                                            textAlign: "left"
                                                        }}>Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        style={{
                                                            borderBottom: "1px solid #ddd" // Consistent border styling
                                                        }}>
                                                        <td style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px" // Consistent padding
                                                        }}>
                                                            <Flex align={"center"} gap={"sm"}>
                                                                <span style={{ width: '20px', height: '20px', background: chart?.dataset?.needleColor ?? "#035e11b0", borderRadius: '1rem' }}></span>
                                                                <p className={styles.link}>Compliance Score</p>
                                                            </Flex>
                                                        </td>
                                                        <td style={{
                                                            padding: "10px",
                                                            border: "1px solid #ddd"
                                                        }}>{contentData?.complianceScore ? parseInt(String(contentData?.complianceScore)) + '%' : 0}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </>

                                    } */}
                                        {/* 
                                    {

                                        chart?.dataSource == 'accessibility_score' &&

                                        <>

                                            <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>


                                                <div style={{ width: '90%', margin: '0 auto' }}>
                                                    <GaugeChart
                                                        id="gauge-chart2"
                                                        style={{ width: '100%' }}
                                                        // nrOfLevels={20}  // Number of segments in the gauge
                                                        percent={contentData?.ialabsScore / 100}   // The value to display (75%)
                                                        textColor={chart?.dataset?.textColor}
                                                        needleColor={chart?.dataset?.needleColor ?? "#035e11b0"}
                                                        colors={chart?.dataset?.colors ?? ["#035e11b0"]}
                                                    />
                                                </div>
                                                <div style={{ width: '100%', textAlign: 'center' }}>
                                                    <Link to="/faq" style={{ textAlign: "center" }} >What is Accessibility Score Overview</Link>
                                                </div>

                                            </div>
                                            <table style={{
                                                border: "1px solid #ddd", // Lighter border color for a softer look
                                                borderCollapse: "collapse",
                                                width: '100%',
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
                                                backgroundColor: "#f9f9f9" // Light background for better readability
                                            }}>
                                                <thead>
                                                    <tr style={{
                                                        backgroundColor: "#f2f2f2", // Slightly darker background for header
                                                        borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
                                                    }}>
                                                        <th style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px", // More padding for a spacious look
                                                            textAlign: "left", // Align text to the left for default
                                                            fontWeight: "bold" // Bold text for headers
                                                        }}>Label</th>
                                                        <th style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px",
                                                            textAlign: "left"
                                                        }}>Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        style={{
                                                            borderBottom: "1px solid #ddd" // Consistent border styling
                                                        }}>
                                                        <td style={{
                                                            border: "1px solid #ddd",
                                                            padding: "10px" // Consistent padding
                                                        }}>
                                                            <Flex align={"center"} gap={"sm"}>
                                                                <span style={{ width: '20px', height: '20px', background: getSCoreColor(contentData?.ialabsScore), borderRadius: '1rem' }}></span>
                                                                <p className={styles.link}>Accessibility Score</p>
                                                            </Flex>
                                                        </td>
                                                        <td style={{
                                                            padding: "10px",
                                                            border: "1px solid #ddd"
                                                        }}>{ parseInt( String(contentData?.ialabsScore))}%</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </>
                                    } */}
                                        {
                                            chart?.dataSource == 'best_ranking_website' &&

                                            <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>
                                                <DashboardTableRanking webSitesData={contentData?.webSitesData} color={chart?.dataset?.color ?? 'green'} />
                                            </div>
                                        }
                                        {
                                            chart?.dataSource == 'high_risk_websites' &&
                                            <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>

                                                <DashboardTableRankingRisk webSitesData={contentData?.webSitesData} color={chart?.dataset?.color ?? 'red'} />
                                            </div>
                                        }

                                        {/* {
                                        chart?.dataSource == 'total_issues_over_time' &&
                                        <>
                                            <div style={{ width: '100%', height: chart?.table ? '350px' : 'auto', margin: '0 auto' }}>

                                                <ScanProgressChart
                                                    config={chart?.dataset}
                                                    issuesCountOverTime={contentData?.issuesCountOverTime}
                                                />

                                            </div>

                                            <div style={{ maxWidth: '95%', overflowX: 'scroll' }}>

                                                <table style={{
                                                    border: "1px solid #ddd", // Lighter border color for a softer look
                                                    borderCollapse: "collapse",
                                                    width: '100%',
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Soft shadow for depth
                                                    backgroundColor: "#f9f9f9" // Light background for better readability
                                                }}>
                                                    <thead>
                                                        <tr style={{
                                                            backgroundColor: "#f2f2f2", // Slightly darker background for header
                                                            borderBottom: "2px solid #ccc" // Thicker, darker line under the header for emphasis
                                                        }}>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px", // More padding for a spacious look
                                                                textAlign: "left", // Align text to the left for default
                                                                fontWeight: "bold" // Bold text for headers
                                                            }}>
                                                                Scan Date</th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px", // More padding for a spacious look
                                                                textAlign: "left", // Align text to the left for default
                                                                fontWeight: "bold" // Bold text for headers
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"}>
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.TotalIssues?.backgroundColor ?? '#2a2b4b', borderRadius: '1rem' }}></span>
                                                                    <p className={styles.link}>Total Issues</p>
                                                                </Flex>
                                                            </th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px", // More padding for a spacious look
                                                                textAlign: "left", // Align text to the left for default
                                                                fontWeight: "bold" // Bold text for headers
                                                            }}>

                                                                <Flex align={"center"} gap={"sm"}>
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.OpenIssues?.backgroundColor ?? '#a3e6e1', borderRadius: '1rem' }}></span>
                                                                    <p className={styles.link}>Open Issues</p>
                                                                </Flex>
                                                            </th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px", // More padding for a spacious look
                                                                textAlign: "left", // Align text to the left for default
                                                                fontWeight: "bold" // Bold text for headers
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"}>
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.ClosedIssues?.backgroundColor ?? '#035e11b0', borderRadius: '1rem' }}></span>
                                                                    <p className={styles.link}>Closed Issues</p>
                                                                </Flex>
                                                            </th>
                                                            <th style={{
                                                                border: "1px solid #ddd",
                                                                padding: "10px", // More padding for a spacious look
                                                                textAlign: "left", // Align text to the left for default
                                                                fontWeight: "bold" // Bold text for headers
                                                            }}>
                                                                <Flex align={"center"} gap={"sm"}>
                                                                    <span style={{ width: '20px', height: '20px', background: chart?.dataset?.NewIssues?.backgroundColor ?? '#da604e', borderRadius: '1rem' }}></span>
                                                                    <p className={styles.link}> New Issues</p>
                                                                </Flex>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {contentData?.issuesCountOverTime?.actual?.length > 0 ? contentData?.issuesCountOverTime?.actual.map((scan, index) => (
                                                            <tr
                                                                key={scan?.date + index}
                                                                style={{
                                                                    borderBottom: "1px solid #ddd" // Consistent border styling
                                                                }}>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>{scan.date}</td>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>{scan.totalIssues}</td>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>{scan.openIssues}</td>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>{scan.closedIssues}</td>
                                                                <td style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px" // Consistent padding
                                                                }}>{scan.openIssues}</td>
                                                            </tr>
                                                        )) :

                                                            <tr>
                                                                <td colSpan={5} style={{
                                                                    border: "1px solid #ddd",
                                                                    padding: "10px",
                                                                    textAlign: "center"
                                                                }}>No data available</td>
                                                            </tr>

                                                        }


                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    } */}
                                        <Space h={"lg"} />
                                    </CardComponent>

                                }
                            </div>
                    })
                        : <Flex h={"40vh"} justify={"center"} align={"center"} w={"100%"} style={{ margin: '0 auto' }} direction={"column"}>
                            <EmptyTable />
                            <p >Dashboard <strong>{dashboard?.dashboardName}</strong> Has No Charts To Display.</p>
                        </Flex>
            }
            <Modal close={closeEdit} opened={openedEdit} zIndex={1000} withCloseButton={true} size={650} padding={"sm"}>
                <Flex align={'center'} justify={'center'} direction={"column"}>
                    <Title order={3}>Edit Chart   </Title>
                </Flex>

                <Flex direction="column" gap="md" p={28}>

                    {/* {selectedChart?.dataSource == 'accessibility_score_progress' && <LineChartOptionComponent editChart={selectedChart} />} */}
                    {["vially_accessibility_overview"].includes(selectedChart?.dataSource ?? "") && <PieChartOptionComponent editChart={selectedChart} dataSource={selectedChart?.dataSource} />}

                    {selectedChart?.dataSource == 'issues_by_priority' && <PieChartOptionComponentPriority editChart={selectedChart} dataSource={selectedChart?.dataSource} />}


                    {selectedChart?.dataSource == 'vially_score' && <SemicircleOption editChart={selectedChart} />}


                    {selectedChart?.dataSource == 'issues_count' && <MultipleBarHorizantalOption editChart={selectedChart} />}

                    {["most_common_accessibility_issues", "most_common_success_criteria"].includes(selectedChart?.dataSource ?? "") && <BarChartOptionComponent editChart={selectedChart} dataSource={selectedChart?.dataSource} />}

                    {/* {["compliance_score", "accessibility_score"].includes(selectedChart?.dataSource ?? "") && <GaugeChartOptionComponent editChart={selectedChart} dataSource={selectedChart?.dataSource ?? ""} />} */}
                    {["high_risk_websites", "best_ranking_website"].includes(selectedChart?.dataSource ?? "") && <WebsiteScoreChartOptionComponent editChart={selectedChart} dataSource={selectedChart?.dataSource ?? ""} />}

                    {/* {selectedChart?.dataSource == 'total_issues_over_time' && <ScanProgressChartOptions editChart={selectedChart} />} */}
                </Flex>

                <Divider />
                <Flex justify={"end"} p={"sm"}>
                    <Button color='gray-light' onClick={() => closeEdit()}>Close</Button>
                </Flex>
            </Modal>

        </div>
    )
}

export default DisplayChartsByDashboard